import { useEffect, useState } from "react";
import { useJobDescription } from "../../../../data/jobDescriptions";
import { Application } from "../../../../dataTypes/Application";
import { DisplayTimestamp } from "../../../../util/timestamps/timestamp";
import { useFindApplicationStatus } from "../../../../data/status";
import { useEmploymentByUserIdAndJobId } from "../../../../data/employee";
import { useEmployer } from "../../../../data/employer";
import SeekerPositionList from "./seekerPositionList";
import { Link } from "react-router-dom";

function SeekerEmploymentListItem({ entry }: { entry: Application }) {
  const [employer, setEmployer] = useState("");
  const { data: JobDataRecords } = useJobDescription(entry.jobId);
  const { data: statusData } = useFindApplicationStatus(entry.status);
  const { data: employerData } = useEmployer(employer);
  const { data: employmentRecord } = useEmploymentByUserIdAndJobId(
    entry.resumeId,
    entry.jobId,
  );

  useEffect(() => {
    if (JobDataRecords && JobDataRecords.hasOwnProperty("employer")) {
      setEmployer(JobDataRecords?.employer);
    }
  }, [JobDataRecords]);

  return (
    <Link
      to={`/employee/${employer}/${employmentRecord?.[0]?.id}/details`}
      target="_blank"
    >
      <div className="text-black font-normal p-2 mb-2 rounded-xl bg-white flex shadow-lg">
        <div className="w-[15%] flex items-center pl-4">
          <img
            src={employerData?.logo}
            alt={employerData?.displayName}
            className="h-12"
          />
        </div>
        <div className="w-[85%] pr-4">
          <div className="w-full text-base text-instant-teams-teal-Main">
            {JobDataRecords?.title}
            <span className="float-right">{statusData?.label}</span>
          </div>
          <div className="w-full text-base text-instant-teams-teal-Main">
            <SeekerPositionList
              applicationId={entry?.id}
              jobId={entry?.jobId}
            />
          </div>
          <div className="w-full mt-2 mb-2 text-xs">
            Date: {DisplayTimestamp(entry?.timestamp)}
          </div>
        </div>
      </div>
    </Link>
  );
}

export default SeekerEmploymentListItem;
